import React from "react";
import { PRIMARY_GREEN } from "../../utility/constants/common-constants";

interface CompletedCircleProps {
  width?: number;
  height?: number;
  variant?: "completed" | "notStarted" | "pending"; // Add "pending" variant
  className?: string;
}

const CheckedCircleIcon: React.FC<CompletedCircleProps> = ({
  width = 21,
  height = 21,
  variant = "completed",
  className,
}) => {
  let fillColor;
  switch (variant) {
    case "completed":
      fillColor = PRIMARY_GREEN;
      break;
    case "notStarted":
      fillColor = "#B0B0B0";
      break;
    case "pending":
      fillColor = "#F7931E";
      break;
    default:
      fillColor = "#B0B0B0";
  }

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 21 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-label={
        variant === "completed"
          ? "Completed status icon"
          : variant === "pending"
          ? "Pending status icon"
          : "Not started status icon"
      }
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.5 1.75C5.67 1.75 1.75 5.67 1.75 10.5C1.75 15.33 5.67 19.25 10.5 19.25C15.33 19.25 19.25 15.33 19.25 10.5C19.25 5.67 15.33 1.75 10.5 1.75ZM8.75 14.875L4.375 10.5L5.60875 9.26625L8.75 12.3988L15.3913 5.7575L16.625 7L8.75 14.875Z"
        fill={fillColor}
      />
    </svg>
  );
};

export default CheckedCircleIcon;

interface PendingIconProps {
  width?: number;
  height?: number;
}

export const PendingIcon: React.FC<PendingIconProps> = ({
  width = 21,
  height = 21,
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 21 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.5 1.75C5.67 1.75 1.75 5.67 1.75 10.5C1.75 15.33 5.67 19.25 10.5 19.25C15.33 19.25 19.25 15.33 19.25 10.5C19.25 5.67 15.33 1.75 10.5 1.75ZM11.375 14.875H9.625V13.125H11.375V14.875ZM11.375 11.375H9.625V6.125H11.375V11.375Z"
        fill="#FDB913"
      />
    </svg>
  );
};
